module.exports = __webpack_public_path__ + "static/img/u70043.3a1606d2.png";